import React from "react";
import { Link } from "react-router-dom";

const BlogDetails = () => {
  return (
    <>
      <section
        className="rs-breadcrumb-area rs-breadcrumb-one p-relative"
        style={{
          paddingTop: "45px",
          paddingBottom: "45px",
        }}
      >
        <div
          className="rs-breadcrumb-bg"
          style={{
            backgroundImage: "url(/assets/images/bg/breadcrumb-bg-01.png)",
          }}
        ></div>
        <div className="container">
          <div className="row">
            <div className="col-xxl-6 col-xl-8 col-lg-8">
              <div className="rs-breadcrumb-content-wrapper">
                <div className="rs-breadcrumb-title-wrapper">
                  <h1 className="rs-breadcrumb-title fs-1">
                    News & Media Details
                  </h1>
                </div>
                <div className="rs-breadcrumb-menu">
                  <nav>
                    <ul>
                      <li>
                        <span>
                          <Link to="/">Home</Link>
                        </span>
                      </li>
                      <li>
                        <span>News & Media Details</span>
                      </li>
                    </ul>
                  </nav>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      <section className="rs-postbox-area section-space">
        <div className="container">
          <div className="row g-5">
            <div className="col-xl-12 col-lg-12">
              <div className="rs-postbox-wrapper">
                <article className="rs-postbox-item">
                  <div className="rs-postbox-thumb">
                    <Link to="/blog-details">
                      <img
                        src="/assets/images/blog/post/blog-post-01.png"
                        alt="imagee"
                      />
                    </Link>
                    <div className="rs-postbox-tag">
                      <Link to="/blog-details">Company</Link>
                    </div>
                  </div>
                  <div className="rs-postbox-content">
                    <div className="rs-postbox-meta-list">
                      <div className="rs-postbox-meta-item">
                        <span className="rs-meta-text">
                          By
                          <Link className="meta-author" to="/blog-details">
                            Industrie
                          </Link>
                        </span>
                      </div>
                      <div className="rs-postbox-meta-item">
                        <span className="rs-postbox-meta-text">
                          <Link to="/blog-details">February 8, 2025</Link>
                        </span>
                      </div>
                    </div>
                    <h3 className="rs-postbox-title">
                      <Link to="/blog-details">
                        Construction of Link new high tech plant in washingtons
                      </Link>
                    </h3>
                    <div className="rs-postbox-text">
                      <p>
                        Industry’s standard dummy text ever since the 1500s,
                        when an unknown printer took Link galley of type and
                        scrambled it to make Link type specimen book. At vero
                        eos et accusamus et iusto odio.
                      </p>
                    </div>
                    <div className="rs-postbox-btn">
                      <Link
                        className="rs-btn has-theme-orange has-icon has-bg"
                        to="/blog-details"
                      >
                        Continue Reading
                        <span className="icon-box">
                          <svg
                            className="icon-first"
                            xmlns="http://www.w3.org/2000/svg"
                            viewBox="0 0 32 32"
                          >
                            <path d="M31.71,15.29l-10-10L20.29,6.71,28.59,15H0v2H28.59l-8.29,8.29,1.41,1.41,10-10A1,1,0,0,0,31.71,15.29Z"></path>
                          </svg>
                          <svg
                            className="icon-second"
                            xmlns="http://www.w3.org/2000/svg"
                            viewBox="0 0 32 32"
                          >
                            <path d="M31.71,15.29l-10-10L20.29,6.71,28.59,15H0v2H28.59l-8.29,8.29,1.41,1.41,10-10A1,1,0,0,0,31.71,15.29Z"></path>
                          </svg>
                        </span>
                      </Link>
                    </div>
                  </div>
                </article>
              </div>
            </div>

            {/* <div className="col-xl-4 col-lg-4">
              <div className="rs-sidebar-wrapper rs-sidebar-sticky">
                <div className="sidebar-widget mb-30">
                  <div className="sidebar-search">
                    <form action="#">
                      <div className="sidebar-search-input">
                        <input type="text" placeholder="Searching..." />
                        <button type="submit">
                          <svg
                            width="18"
                            height="18"
                            viewBox="0 0 18 18"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                          >
                            <path
                              d="M8.11111 15.2222C12.0385 15.2222 15.2222 12.0385 15.2222 8.11111C15.2222 4.18375 12.0385 1 8.11111 1C4.18375 1 1 4.18375 1 8.11111C1 12.0385 4.18375 15.2222 8.11111 15.2222Z"
                              stroke="currentColor"
                              stroke-width="2"
                              stroke-linecap="round"
                              stroke-linejoin="round"
                            ></path>
                            <path
                              d="M16.9995 17L13.1328 13.1333"
                              stroke="currentColor"
                              stroke-width="2"
                              stroke-linecap="round"
                              stroke-linejoin="round"
                            ></path>
                          </svg>
                        </button>
                      </div>
                    </form>
                  </div>
                </div>
                <div className="sidebar-widget widget-categories-two mb-30">
                  <h5 className="sidebar-widget-title">Categories</h5>
                  <div className="sidebar-widget-content">
                    <div className="list">
                      <ul>
                        <li>
                          <Link to="#">
                            Bridge Construction
                            <i className="ri-arrow-right-line"></i>
                          </Link>
                        </li>
                        <li>
                          <Link to="#">
                            High regulation industry
                            <i className="ri-arrow-right-line"></i>
                          </Link>
                        </li>
                        <li>
                          <Link to="#">
                            Industrial Construction
                            <i className="ri-arrow-right-line"></i>
                          </Link>
                        </li>
                        <li>
                          <Link to="#">
                            Mechanical Engineering
                            <i className="ri-arrow-right-line"></i>
                          </Link>
                        </li>
                        <li>
                          <Link to="#">
                            Oil &amp; Gas Energy
                            <i className="ri-arrow-right-line"></i>
                          </Link>
                        </li>
                        <li>
                          <Link to="#">
                            Manufacturing solutions
                            <i className="ri-arrow-right-line"></i>
                          </Link>
                        </li>
                      </ul>
                    </div>
                  </div>
                </div>
                <div className="sidebar-widget mb-30">
                  <h5 className="sidebar-widget-title">Recent Posts</h5>
                  <div className="sidebar-widget-content">
                    <div className="sidebar-blog-item-wrapper">
                      <div className="sidebar-blog-item">
                        <div className="sidebar-blog-thumb">
                          <Link to="/blog-details">
                            <img
                              src="assets/images/blog/sidebar/blog-sm-01.png"
                              alt="imagee"
                            />
                          </Link>
                        </div>
                        <div className="sidebar-blog-content">
                          <h6 className="sidebar-blog-title">
                            <Link to="/blog-details">
                              Construction of Link new high tech plant
                            </Link>
                          </h6>
                          <div className="sidebar-blog-meta">
                            <i className="ri-calendar-line"></i>
                            <span>May 20, 2024</span>
                          </div>
                        </div>
                      </div>
                      <div className="sidebar-blog-item">
                        <div className="sidebar-blog-thumb">
                          <Link to="/blog-details">
                            <img
                              src="assets/images/blog/sidebar/blog-sm-02.png"
                              alt="imagee"
                            />
                          </Link>
                        </div>
                        <div className="sidebar-blog-content">
                          <h6 className="sidebar-blog-title">
                            <Link to="/blog-details">
                              Building resilient supply chains for industries
                            </Link>
                          </h6>
                          <div className="sidebar-blog-meta">
                            <i className="ri-calendar-line"></i>
                            <span>May 20, 2024</span>
                          </div>
                        </div>
                      </div>
                      <div className="sidebar-blog-item">
                        <div className="sidebar-blog-thumb">
                          <Link to="/blog-details">
                            <img
                              src="assets/images/blog/sidebar/blog-sm-03.png"
                              alt="imagee"
                            />
                          </Link>
                        </div>
                        <div className="sidebar-blog-content">
                          <h6 className="sidebar-blog-title">
                            <Link to="/blog-details">
                              Factories technologies in interactive and plants
                            </Link>
                          </h6>
                          <div className="sidebar-blog-meta">
                            <i className="ri-calendar-line"></i>
                            <span>May 20, 2024</span>
                          </div>
                        </div>
                      </div>
                      <div className="sidebar-blog-item">
                        <div className="sidebar-blog-thumb">
                          <Link to="/blog-details">
                            <img
                              src="assets/images/blog/sidebar/blog-sm-01.png"
                              alt="imagee"
                            />
                          </Link>
                        </div>
                        <div className="sidebar-blog-content">
                          <h6 className="sidebar-blog-title">
                            <Link to="/blog-details">
                              Building resilient supply for industries and
                              factorie
                            </Link>
                          </h6>
                          <div className="sidebar-blog-meta">
                            <i className="ri-calendar-line"></i>
                            <span>May 20, 2024</span>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="sidebar-widget">
                  <h5 className="sidebar-widget-title">Popular Tags</h5>
                  <div className="sidebar-widget-content tagcloud">
                    <Link to="#">Construction</Link>
                    <Link to="#">Factory</Link>
                    <Link to="#">Gas</Link>
                    <Link to="#">Industry</Link>
                    <Link to="#">Manufacture</Link>
                    <Link to="#">Metallurgy</Link>
                    <Link to="#">Oil</Link>
                    <Link to="#">Robotic</Link>
                  </div>
                </div>
              </div>
            </div> */}
          </div>
        </div>
      </section>
    </>
  );
};

export default BlogDetails;
